var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _vm.$slots.prefix ? _vm._t("prefix") : _vm._e(),
      _c(
        "label",
        {
          class: {
            [_vm.$style.counter]: true,
            [_vm.$style.maxed]: _vm.data.length >= _vm.max,
          },
          style: _vm.counter,
          attrs: { for: _vm.name },
        },
        [_vm._v(_vm._s(_vm.data.length) + "/" + _vm._s(_vm.max))]
      ),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.data,
            expression: "data",
          },
        ],
        ref: "editor",
        class: _vm.styles,
        attrs: {
          id: _vm.name,
          placeholder: _vm.placeholder,
          maxlength: _vm.max,
        },
        domProps: { value: _vm.data },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.data = $event.target.value
            },
            _vm.autoexpand,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "i",
        {
          staticClass: "material-icons",
          class: _vm.$style.clear,
          on: { click: _vm.clear },
        },
        [_vm._v("delete")]
      ),
      _c(
        "i",
        {
          staticClass: "material-icons",
          class: {
            [_vm.$style.save]: true,
            [_vm.$style.active]: _vm.value !== _vm.data,
          },
          on: { click: _vm.save },
        },
        [_vm._v("check_circle")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }